import { IonIcon } from '@ionic/react'
import { openOutline } from 'ionicons/icons'
import { myPalette } from '../theme'

export function MenuOkodriveIcon() {
  return (
    <div
      style={{
        padding: '8px',
        borderRadius: '100%',
        background: myPalette.midnightBlue.main,
        display: 'flex',
      }}
    >
      <IonIcon
        icon={openOutline}
        style={{
          color: myPalette.white.main,
          width: '20px',
          height: '20px',
        }}
      />
    </div>
  )
}
